import { render, staticRenderFns } from "./KiPilotPraxisRouteList.vue?vue&type=template&id=59b9b1f4&scoped=true&"
import script from "./KiPilotPraxisRouteList.vue?vue&type=script&lang=ts&"
export * from "./KiPilotPraxisRouteList.vue?vue&type=script&lang=ts&"
import style0 from "./KiPilotPraxisRouteList.vue?vue&type=style&index=0&id=59b9b1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9b1f4",
  null
  
)

export default component.exports